// extracted by mini-css-extract-plugin
export var currencyInput = "_mm-1";
export var currencySymbol = "_mm-0";